import { useDispatch } from 'react-redux';
import { AppDispatch } from './DynamicStore';

const useAppDispatch = () => useDispatch<AppDispatch>();

export default useAppDispatch;
